import type {ConfigTypeMap} from "dayjs";
import 'dayjs/locale/en';
import 'dayjs/locale/nl';
import 'dayjs/locale/nb';

export function getDayJsLocale(locale: string): string {
    switch (locale) {
        case 'en-us':
            return 'en';
        case 'nl-nl':
            return 'nl';
        default:
            return locale;
    }
}

export type DayJsObject = ConfigTypeMap['objectSupport'];
